import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57c041d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fileicon" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "filename" }
const _hoisted_4 = { class: "extinfo" }
const _hoisted_5 = { class: "operations" }

import { computed } from 'vue'
import { FloderIcon } from '@remote/utils/file-helper'
// import FileIcon from './file-icon.vue'
// import { parseTime, bytesToSize } from '@remote/utils'

interface IFileInfo {
  type: 'folder'
  path: string
  name: string
  ut: string
}
interface IProps {
  file: IFileInfo
  selecting: boolean
  selecteds: string[]
}
interface IEmits {
  (e: 'select', file: IFileInfo): void
  (e: 'click', file: IFileInfo): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    file: null,
    selecting: { type: Boolean },
    selecteds: null
  },
  emits: ["select", "click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'select', file: IFileInfo): void
  (e: 'click', file: IFileInfo): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  file: IFileInfo
  selecting: boolean
  selecteds: string[]
}


const isCurrentSelected = computed(() => props.selecteds.includes(props.file.path))
const iconUrl = computed(() => FloderIcon)
const labels = computed(() => {
  const file = props.file
  const { ut } = file
  const updateTime = ut
  const labels: string[] = updateTime ? [updateTime] : []

  return labels
})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["file", {
      'is-selected': _unref(isCurrentSelected),
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "f_icon",
        src: _unref(iconUrl),
        alt: "file_icon"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", {
      class: "fileinfo",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click', __props.file)))
    }, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(__props.file.name), 1),
      _createElementVNode("h6", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(labels), (label) => {
          return (_openBlock(), _createElementBlock("span", { key: label }, _toDisplayString(label), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", {
        class: _normalizeClass([{
          'qh-icon-check': !_unref(isCurrentSelected),
          'qh-icon-checked': _unref(isCurrentSelected),
          'is-selecting': !__props.selecting,
        }, "check-icon"]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emits('select', __props.file)), ["stop"]))
      }, null, 2)
    ])
  ], 2))
}
}

})